import React, { Fragment } from 'react';
import support from '../../../../images/supportticket.png';

const IncidentReport = () => (
  <Fragment>
    <ol>
      <li>
        Open the Autzu app and select the “Support” button on the
        navigation bar.
      </li>
      <li>
        Tap “New support” and fill in the required information then press
        "Next".
      </li>
    </ol>
    <p>We will be sure to respond to you as soon as possible.</p>
    <div style={{ textAlign: 'center' }}>
      <img src={support} style={{ width: '200px', height: '455px' }} />
    </div>
  </Fragment>
);

export default IncidentReport;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/StartYourBooking/IncidentReport.js